import registry from "~/components/DoRegistry.js";
import inputErrorTpl from "./inputError.hbs";

class DoForm{
    constructor($target){
        this.$target = $target;
    }

    markError($input, msg, removeOnChange){
        if(!$input.next().next().hasClass("error")){
            let $err = $(inputErrorTpl({message: msg}));
            $err.insertAfter($input);

            $input.addClass('error');

            if(removeOnChange) $input.one("change blur keydown", ()=>{
                $input.removeClass('error');
                $err.remove();
            });
        }
    }
}

registry.register(__filename, DoForm);
export default DoForm;
